export default __webpack_public_path__ + "static/thumb-bananas-35a60d2c5f00991c2f662312863f12d2.png";